import { useEffect } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import type { JoinContributorDataContext } from '@scale/genai-compass-shared/cards/join_contributor_data';

function useJoinContributorDataCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit } = useCompassCard(index);
  const { retrievedOutput } = useCompassCard(index - 1);
  const context = card.defaultContext as JoinContributorDataContext;
  const columns = retrievedOutput?.response?.schema ?? [];

  useEffect(() => {
    updateCardCanSubmit(
      !!context.contributorIdsColumnName && context.contributorIdsColumnName.length > 0,
    );
  }, [context.contributorIdsColumnName]);

  const setContributorIdsColumnName = (contributorIdsColumnName: string) => {
    updateCardContext({ ...context, contributorIdsColumnName } as JoinContributorDataContext);
  };

  return {
    card,
    columns,
    contributorIdsColumnName: context.contributorIdsColumnName,
    setContributorIdsColumnName,
  };
}

export default useJoinContributorDataCard;
